/**
 * Schema Redirect Configuration
 *
 * Maps (schema name, HTTP method) pairs to API function names for URL
 * interception. When a document request is made for a configured schema,
 * the URL will be rewritten to route through the API function registered
 * for that HTTP method.
 */

export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export type SchemaMethodMap = Partial<Record<HttpMethod, string>>;

export interface SchemaRedirectConfig {
  [schemaName: string]: SchemaMethodMap;
}

/**
 * Active schema redirections.
 * Add or remove entries to control which schemas route through API functions.
 */
export const schemaRedirects: SchemaRedirectConfig = {
  patient: {
    GET: "patient-read",
    POST: "patient-endpoint",
    PUT: "patient-endpoint",
  },
};

/**
 * Check if a (schema, method) pair is configured for redirection
 */
export const isSchemaRedirected = (schemaName: string, method: HttpMethod): boolean =>
  Boolean(schemaRedirects[schemaName]?.[method]);

/**
 * Get the API function name for a redirected (schema, method) pair
 */
export const getRedirectedFunctionName = (schemaName: string, method: HttpMethod): string | null =>
  schemaRedirects[schemaName]?.[method] ?? null;
